module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', [_vm._v("“As long as I can remember I’ve wanted to make a record with my dad."), _c('br'), _vm._v("He’s the one who taught me how to play.”")])]), _vm._v(" "), _c('p', {
    staticClass: "epiaut1"
  }, [_c('i', [_vm._v("—Billy Strings")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#A_1",
      "id": "B_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As a guitarist, Billy Strings is a generational talent, but even extremely gifted musicians need mentorship and guidance to get started. For Billy, it was his father, Terry Barber, who taught him to play guitar. In November 2022, Billy released the album "), _c('i', [_vm._v("Me / and / Dad")]), _vm._v(", a collaboration and tribute to the man who got him started.")]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jeff Campbell with Dallas music historian Roy Wood. “Uncle” Roy has given away dozens of musical instruments to aspiring musicians. The consummate example of “play it forward.” "), _c('i', [_vm._v("Photo courtesy of the Kanikapila Island Strummers.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s really what this book is about: families and mentors, as they relate to the Texas bluegrass scene. It could easily be another state or another subject. There could be books like this one on Oregon fishermen, Massachusetts artists or Colorado cowboys and cowgirls."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#A_2",
      "id": "B_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Because most all of us have found success due to our families or mentors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I get older, I think of my family and my mentors and what they have taught me. Some of them have passed on, and the best thing I can do is pass on the things they have taught me. Because without them, I probably would not be writing these words right now.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Jeff Campbell")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aabef744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preface.vue
// module id = 75
// module chunks = 0